import styled from 'styled-components'

export const PopUp = styled.div`
  width: 100vw;
  position: absolute;
  top: 0;
  z-index: 10;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  background-color: #f3f4f8;
  align-items: center;
`
export const EditCard = styled.div`
  width: 70%;
  background-color: #f3f4f8;
  padding: 4rem 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 2rem;
`
export const StyledIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${(props) => props.theme.colors.red};
  cursor: pointer;
  padding: 0.75rem 1rem;
  box-sizing: border-box;
  border-radius: 20px;
  width: fit-content;
`
export const StyledInputs = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;
`

export const StyledInput = styled.div`
  direction: rtl;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 2rem;
  position: relative;
`
export const Cards = styled.div.attrs((props: { width: boolean }) => props)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  width: 70%;
  gap: 2rem;
`

export const StyledAnswers = styled.div`
  width: 100%;
  display: flex;
  gap: 2rem;
`

export const StyledCard = styled.div`
  width: 100%;
  direction: rtl;
  display: flex;
  justify-content: center;
  gap: 1.25rem;
`

export const StyledButtons = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.25rem;
`
export const Drop = styled.div`
  width: 70%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  padding: 1rem 0;
  border-bottom: 2px solid black;
`
export const StyledDiv = styled.div`
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 1rem;
`

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4rem;
  flex-wrap: wrap;
  position: relative;
  flex-direction: row-reverse;
`
export const IconAbsolute = styled.a`
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 1rem;
  cursor: pointer;
  border-radius: 20px;
  transition: all 0.4s;
`

export const StyledCardTrainingGroup = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  flex-direction: column;
  box-sizing: border-box;
  padding: 1rem;
  box-shadow: ${(props) => props.theme.boxShadow.shadow3};
  width: 20rem;
  background-color: ${(props) => props.theme.colors.white};
  height: 16rem;
  text-decoration: none;
  color: ${(props) => props.theme.colors.black};
  transition: all 0.4s;
  position: relative;
  &:hover {
    color: ${(props) => props.theme.colors.white};
    background: ${(props) => props.theme.colors.red};
    transform: translateY(-8px);
  }
  &:hover ~ ${IconAbsolute} {
    color: ${(props) => props.theme.colors.white};
    transform: translateY(-8px);
  }
`

export const RelativeDiv = styled.div`
  position: relative;
`
